import { MarketplaceInstallationFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { useCompanyInstallations } from 'modules/marketplace/store/collections/companyInstallations'

type FormDataValue = string | string[] | number | boolean
interface FormData {
  [key: string]: FormDataValue
}

export const useUpdateInstallation = () => {
  const {
    company: { id: companyId },
    access: { id: accessId },
  } = useCurrentSession()
  const companyInstallations = useCompanyInstallations()

  const updateInstallation = async (
    installation: MarketplaceInstallationFragment,
    newFormData: FormData
  ) => {
    if (!installation.formData) return

    await companyInstallations.fetch()
    const model = companyInstallations.find({
      integration_id: installation.integrationId,
    })
    const newData = JSON.parse(JSON.stringify(newFormData))
    const payload = {
      integration_id: installation.integrationId,
      form_data: newData,
      company_id: companyId,
      access_id: accessId,
    }

    const { success } = await asyncAction(
      async () => {
        await model?.update(payload)
      },
      { loadingMessage: i18n.t('common.loading'), successFlash: true }
    )
    return success
  }

  return { updateInstallation }
}
